import LocalStorageCache from 'lyjs/es/cache/LocalStorageCache'

export default new LocalStorageCache('user')
